var map = {
	"./dashboard/routes.ts": 6773,
	"./emissao-certificado/atualizacao-conclusao-ensino/routes.ts": 8578,
	"./emissao-certificado/manutencao-registro-certificado-geja/routes.ts": 4130,
	"./emissao-certificado/manutencao-registro-certificado/routes.ts": 960,
	"./relacao-de-alunos-concludentes/routes.ts": 9375,
	"./tabelas-basicas/livros-e-formularios/manutencao-de-livro-de-registro-de-certificado/routes.ts": 9349,
	"./tabelas-basicas/livros-e-formularios/manutencao-remessa-formulario/routes.ts": 3254,
	"./tabelas-basicas/parametrizacao-certificados/manutencao-parametro-certificado/routes.ts": 6132,
	"./tabelas-basicas/parametrizacao-certificados/manutencao-tipo-certificado-ensino/routes.ts": 4993,
	"./tabelas-basicas/parametrizacao-certificados/manutencao-tipo-certificado/routes.ts": 2928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3019;